import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export const UrgencyBar = () => {
  const {
    formatted,
    barPct
  } = useCountdown();
  return <div className="w-full bg-gradient-to-r from-red-900/40 via-orange-900/40 to-red-900/40 border-t border-bttf-primary/20 py-2 px-4" data-id="element-578">
      <div className="container mx-auto flex items-center justify-between gap-2 md:gap-4" data-id="element-579">
        {/* Left text */}
        <span className="text-xs md:text-sm text-bttf-text font-medium flex-shrink-0 leading-tight" data-id="element-580">
          ⚡ This price won't come back. Neither will 1985.
        </span>

        {/* Right: bar (desktop only) + countdown */}
        <div className="flex items-center gap-2 flex-shrink-0" data-id="element-581">
          <div className="hidden md:block w-32" data-id="element-582">
            <div className="h-1.5 bg-black/60 rounded-full overflow-hidden" data-id="element-583">
              <div className="h-full bg-gradient-to-r from-red-600 to-red-500 transition-all duration-1000 ease-linear" style={{
              width: `${barPct}%`
            }} data-id="element-584"></div>
            </div>
          </div>
          <span className="text-xs md:text-sm text-bttf-primary font-bold tabular-nums whitespace-nowrap font-future" data-id="element-585">
            {formatted}
          </span>
        </div>
      </div>
    </div>;
};